(() => {
  if (window.mmLinksWithImageTabsBound) return;
  window.mmLinksWithImageTabsBound = true;

  const init = () => {
    document.querySelectorAll('links-with-image').forEach((section) => {
      const buttons = [...section.querySelectorAll('.big-link[aria-pressed]')];
      if (!buttons.length || section.dataset.mmTabsReady === 'true') return;
      section.dataset.mmTabsReady = 'true';

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
          button.focus({ preventScroll: true });
        });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
